import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  getFilters,
  updateActiveTab,
  updateSelectedFilters,
  changeFilterContainerVisibility,
  resetDrillDown,
  deleteFilter,
  startEditFilter,
} from '@store/filterContainer/actions';
import {
  applyTrendsSelectedNocFilters,
  updateSavedFiltersSelectedNocFilters,
} from '@store/noc/base/actions';
import { setAppliedFilters as applyMLFilter } from '@store/metricLens/base/actions';
import { pushDrilldownFilter } from '@store/dimensionContainer/actions';
import { applyFilter, toggleModal } from '@store/common/actions';
import { addSavedFilters } from '@store/comparison/actions';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { selector as commonSelector } from '@store/common';
import {
  selectedUserRoleSelector,
  isAdminRoleSelector,
  getUserProfile,
} from '@store/common/selectors';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { nocDrawerShowSelector } from '@store/noc/drawer/selectors';
import { activeDashboardSelector } from '@store/tempDashboard/selectors';
import { selector as comparisonSelector } from '@store/comparison';
import { selector as routeSelector } from '@store/router';
import FilterContainer from './FilterContainer';

const selector = createSelector(
  filterContainerSelector,
  commonSelector,
  comparisonSelector,
  routeSelector,
  selectedUserRoleSelector,
  nocDrawerShowSelector,
  isAdminRoleSelector,
  getUserProfile,
  allDimensionsListSelector,
  activeDashboardSelector,
  // eslint-disable-next-line max-len
  (
    filterContainer,
    common,
    comparison,
    router,
    userRole,
    nocDrawerShow,
    isAdmin,
    userProfile,
    allDimensions,
    activeDashboard,
  ) => ({
    activeTabKey: filterContainer.activeTabKey,
    type: filterContainer.type,
    filters: filterContainer.filters,
    defaultFilters: filterContainer.defaultFilters,
    appliedFilters: common.appliedFilters,
    features: common.features,
    selectedFilters: filterContainer.savedFilterPanel.selectedFilters,
    compareMode: common.compareMode,
    savedFilters: comparison.savedFilters,
    compareDrawer: { filterBars: [] }, // TODO: cleanup filter flow for compare
    router,
    modal: common.modal,
    userRole,
    nocDrawerShow,
    isAdmin,
    userProfile,
    allDimensions,
    dataScope: activeDashboard?.dataScope,
  }),
);

export default connect(selector, {
  updateActiveTab,
  getFilters,
  applyFilter,
  updateSelectedFilters,
  applyTrendsSelectedNocFilters,
  applyMLFilter,
  updateSavedFiltersSelectedNocFilters,
  changeFilterContainerVisibility,
  resetDrillDown,
  pushDrilldownFilter,
  addSavedFilters,
  toggleModal,
  deleteFilter,
  startEditFilter,
})(FilterContainer);
